export const ROUTES = {
  LANDING: '/',
  // LOGIN removed: no in-app login page. Use keycloak.login() to start auth.
  REGISTER: '/register',
  ACCEPT_INVITE: '/accept-invite',
  NO_ORGANIZATION: '/onboarding/no-organization',
  ORG_REGISTRATION: '/onboarding/organization',
  WAITING_APPROVAL: '/onboarding/waiting-approval',
  REJECTED_ORGANIZATION: '/onboarding/rejected',
  HOME: '/admin/dashboard',
  UNAUTHORIZED: '/unauthorized',
  DIRECTORY: '/directory',
  DASHBOARD: '/assets/dashboard',
  ASSETS: '/assets',
  VULNERABILITIES: '/vulnerabilities',
  CREATE_ASSET: '/assets/create',
  // Adding an asset by installing the agent, which enrolls the machine itself.
  // Was the standalone "Agents" page at /agents.
  ENROLL_ASSET: '/assets/enroll',
  ASSET_DETAIL: '/assets/:id',
  EDIT_ASSET: '/assets/:id/edit',
  ADMIN_ORGANIZATIONS: '/admin/organizations',
  ADMIN_ORGANIZATION_DETAIL: '/admin/organizations/:slug',
  ADMIN_PENDING: '/admin/pending-organizations',
  ADMIN_USERS: '/admin/users',
  ADMIN_ROLES: '/admin/roles',
  ADMIN_USER_DETAIL: '/admin/users/:slug',
  TEAM: '/team',
  USER_PROFILE: '/profile',
  SUPPORT: '/support',
  SUPPORT_ADMIN: '/admin/support',
  ADMIN_AUDIT_LOGS: '/admin/audit-logs',
  ANALYTICS: '/analytics',
  DASHBOARD_BUILDER: '/dashboards',
  ADMIN_EXTERNAL_API_KEYS: '/admin/external-api-keys',

  // Platform admin — Sold Services / Revenue
  ADMIN_SERVICES: '/admin/services',
  ADMIN_SERVICES_SOLD: '/admin/services/sold',

  // NIRP routes
  NIRP_ORG_DASHBOARD: '/nirp/dashboard',
  NIRP_SUBMIT_INCIDENT: '/nirp/submit',
  NIRP_MY_INCIDENTS: '/nirp/incidents',
  NIRP_THREAT_DASHBOARD: '/nirp/threat-intel/dashboard',
  NIRP_UPLOAD: '/nirp/upload',
  NIRP_THREAT_FEED: '/nirp/threat-feed',
  NIRP_MESSAGES: '/nirp/messages',
  NIRP_PROFILE: '/nirp/profile',
  NIRP_ADMIN_DASHBOARD: '/nirp/admin/dashboard',
  NIRP_ADMIN_INCIDENTS: '/nirp/admin/incidents',
  NIRP_ADMIN_THREAT_INTEL: '/nirp/admin/threat-intel',
  NIRP_ADMIN_THREAT_SHARE_QUEUE: '/nirp/admin/threat-shares',
  NIRP_ADMIN_THREAT_SHARE_CREATE: '/nirp/admin/threat-shares/create',

  // CMS — Case Management System
  CMS: '/cms',
  CMS_DASHBOARD: '/cms/dashboard',
  CMS_CASES: '/cms/cases',
  CMS_CASE_BOARD: '/cms/cases/board',
  CMS_CASE_DETAIL: '/cms/cases/:id',
  CMS_ALERTS: '/cms/alerts',
  CMS_ALERT_DETAIL: '/cms/alerts/:id',
  CMS_REPORTS: '/cms/reports',
  CMS_ALERT_SOURCES: '/cms/sources',
  CMS_TEAM: '/cms/team',
  CMS_NOTIFICATIONS: '/cms/notifications',
  CMS_AUDIT: '/cms/audit',
  CMS_SETTINGS: '/cms/settings',
  CMS_METRICS: '/cms/metrics',
  CMS_CERT_COLLABORATION: '/cms/cert-collaboration',
  // Operator console. Only reachable in the hosted bundle, and only by
  // platform_admin, who is not a tenant and has no organization of their own.
  CMS_TENANTS: '/cms/tenants',
  // Kibo's customer register and on-premise license issuing. platform_admin
  // only, in the platform and hosted bundles; never served on-premise.
  CMS_CUSTOMERS: '/cms/customers',

  // CERT Cooperation Portal (public — no Keycloak, token-authenticated)
  CERT_PORTAL: '/cert/access',

  // TBA placeholder
  TBA: '/tba',
  SENTRY_TEST: '/sentry-test',
} as const;
